<template>
  <div class="info-card">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',
};
</script>
<style scoped lang="scss">
.info-card {
  background-color: #f0f4f7;
  padding: 16px;
  border-radius: 4px;
}
</style>
